import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import React from "react";
import { AzureConfig } from "../../AuthProvider";
import { msalConfig } from "./AzureADAuthConfig";
import { LoginWithAzureADForm } from "./LoginWithAzureADForm";

export const LoginWithAzureAD = ({ config }: { config: AzureConfig }) => {
	const msalInstance = new PublicClientApplication({
		...msalConfig,
		...{
			auth: {
				...config,
			},
		},
	});

	return (
		<>
			<MsalProvider instance={msalInstance}>
				<LoginWithAzureADForm />
			</MsalProvider>
		</>
	);
};
